const globalScope = typeof window !== 'undefined' ? window : globalThis

const i18nTranslations = {
	uk: {},
	ru: {},
}

function getNestedValue(obj = {}, path = '') {
	if (!path) return undefined
	return String(path).split('.').reduce((current, prop) => {
		if (!current || typeof current !== 'object') return undefined
		return Reflect.get(current, prop)
	}, obj)
}

export function setI18nTranslations(translations = {}) {
	if (!translations || typeof translations !== 'object' || Array.isArray(translations)) return

	const uk = Reflect.get(translations, 'uk')
	const ru = Reflect.get(translations, 'ru')

	if (uk && typeof uk === 'object' && !Array.isArray(uk)) {
		i18nTranslations.uk = {
			...i18nTranslations.uk,
			...uk,
		}
	}

	if (ru && typeof ru === 'object' && !Array.isArray(ru)) {
		i18nTranslations.ru = {
			...i18nTranslations.ru,
			...ru,
		}
	}
}

export function getCurrentLanguage() {
	const shopify = Reflect.get(globalScope, 'Shopify')
	const locale = shopify && typeof shopify === 'object' ? Reflect.get(shopify, 'locale') : ''
	return locale === 'ru' ? 'ru' : 'uk'
}

export function translate(key = '', lang = '') {
	const currentLang = lang === 'ru' || lang === 'uk' ? lang : getCurrentLanguage()
	const keyPath = String(key)
	const langData = currentLang === 'ru' ? i18nTranslations.ru : i18nTranslations.uk

	return (
		getNestedValue(langData, keyPath)
		?? getNestedValue(i18nTranslations.uk, keyPath)
		?? keyPath
	)
}

export function createTranslator(lang = '') {
	return (key = '') => translate(key, lang)
}

export function createScopedTranslator(scope = '', lang = '') {
	return (key = '') => {
		const keyPath = key ? `${scope}.${key}` : scope
		return translate(keyPath, lang)
	}
}

const existingTranslations = Reflect.get(globalScope, 'i18nTranslations')
if (existingTranslations && typeof existingTranslations === 'object' && !Array.isArray(existingTranslations)) {
	setI18nTranslations(existingTranslations)
}

Reflect.set(globalScope, 'getCurrentLanguage', getCurrentLanguage)
Reflect.set(globalScope, 'translate', translate)
Reflect.set(globalScope, 't', translate)
Reflect.set(globalScope, 'setI18nTranslations', setI18nTranslations)
